<template>
  <div class="layout-sidebar" @click="onMenuClick">
    <router-link to="/" class="logo grid grid-nogutter flex gap-2">
      <img id="app-logo" :src="logoSrc" alt="diamond-vue" :class="{ 'logoImg': isSda }"   />
      <span v-if="!isSda" class="app-name col-5">{{ getTenant==='smeg' ? 'Professional' : 'Consumer' }}</span>
    </router-link>
    <div>
      <profile class="layout-menu-container-top"></profile>
      <!-- <div class="tenants-dropdown layout-menu-container-top"> XXX_TENANT_XXX
        <Dropdown :disabled="toggleTenant" v-model="selectTenant" :options="tenants" optionLabel="label"
          class="w-full md:w-14rem" @change="setNewTenant" style="color: white" />
      </div> -->
    </div>
    <hr style="width: 90%; margin-top: 20px;">
    <div class="layout-menu-container">
      <AppSubmenu :items="model" :layoutMode="layoutMode" :parentMenuItemActive="true" :menuActive="active"
        :mobileMenuActive="mobileMenuActive" :root="true" @menuitem-click="onMenuItemClick"
        @root-menuitem-click="onRootMenuItemClick" />
      <div>
        <div class="logout-container" @click="logout_function()">
          <img src="/images/logout.png" class="img-logout" alt="Logout"/>
          <h4 class="logout">{{this.$t("menu_logout")}}</h4>
        </div>
        <div class="mt-4 text-center text-xs text-white" style="user-select: text;">
          {{this.$t("menu_softwareVersion")}}: {{ $config.projectVersion }}
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu.vue";
import { mapActions, mapState } from "pinia";
import { useLoginStore } from "./stores/login.js";
import { useApplianceStore } from "./stores/appliance.js";
import { useBreadcrumbStore } from "./stores/breadcrumb.js";
import { useCampaignsStore } from "./stores/campaign.js";
import { useAnalyticsStore } from "./stores/charts.js";
import { useGroupsStore } from "./stores/group.js";
import { useReportStore } from "./stores/reports.js";
import { useTagsStore } from "./stores/tags.js";
import { useUsersStore } from "./stores/user.js";
import Profile from "./components/Profile.vue";
export default {
  data() {
    return {
      selectTenant: null,
      tenants: [],
      test: false
    }
  },

  components: { AppSubmenu, Profile },
  name: "AppMenu",
  emits: ["menu-click", "menuitem-click", "root-menuitem-click", "menu-update"],
  props: {
    model: Array,
    layoutMode: String,
    active: Boolean,
    mobileMenuActive: Boolean,
  },
  actions: {
    ...mapActions(useLoginStore, ["setTenant"]),
  },
  computed: {
    ...mapState(useLoginStore, ["getAbacConfig", "getTenant"]),
    toggleTenant() {
      if (this.tenants.length === 1) {
        return true;
      } else {
        return false;
      }
    },
    logoSrc() {
      return this.isSda ? '/images/assistant_logo.svg' : '/images/connect_logo.png';
    },
    isSda() {
      return this.getAbacConfig?.role_def?.subtenant?.length==1 && this.getAbacConfig?.role_def?.subtenant?.[0] === 'sda';
    }
  },
  mounted() {
    // if (this.getAbacConfig) { XXX_TENANT_XXX
    //   let tenant_abac = (this.getAbacConfig).tenants;
    //   for (let i = 0; i < tenant_abac.length; i++) {
    //     let obj = {
    //       label: this.getTenantLabel(tenant_abac[i]),
    //       key: tenant_abac[i]
    //     }
    //     this.tenants.push(obj);
    //   }

    // }

    // this.selectTenant = { label: this.getTenantLabel(this.getTenant), key: this.getTenant };
  },

  methods: {
    ...mapActions(useLoginStore, ["logout", "setTenant", "setAbacConfig"]),
    async setNewTenant() {
      //Reset stores
      useApplianceStore().$reset();
      useBreadcrumbStore().$reset();
      useCampaignsStore().$reset();
      useAnalyticsStore().$reset();
      useGroupsStore().$reset();
      useReportStore().$reset();
      useTagsStore().$reset();
      useUsersStore().$reset();


      this.setTenant(this.selectTenant);
      await this.setAbacConfig(this.getTenant);

      if (this.$route.name === "Appliances") {
        location.reload();
      } else {
        this.$router.push({
          name: "Appliances",
        });
        this.$emit("menu-update", {
        });
      }

    },
    onMenuClick(event) {
      this.$emit("menu-click", event);
    },
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
    onRootMenuItemClick(event) {
      this.$emit("root-menuitem-click", event);
    },
    async logout_function() {
      await this.logout();
      this.$router.push({
        name: "login-"+this.getTenant,
      });
    },

    getTenantLabel(label) {
      switch (label) {
        case 'smeg':
          return "Smeg Professional";
        case 'smegcons':
          return "Smeg Consumer";
        default:
          return null;
      }
    },
  }
};
</script>


<style>
  .logoImg {
    filter: invert(100%);
  }
</style>